module.exports = __webpack_public_path__ + "static/portfolio-mas-5-49f46793bbbc50cbc1808a6784ec5a3f.jpg";